import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { CTAButton } from '../ui/CTAButton';
import { Gift, CheckCircle2, ShieldCheck } from 'lucide-react';
export function BonusesSection() {
  return <section className="py-24 px-6 bg-cream" data-id="element-16">
      <div className="max-w-4xl mx-auto" data-id="element-17">
        {/* BLOCK 1 */}
        <FadeIn data-id="element-18">
          <div className="text-center mb-16" data-id="element-19">
            <h2 className="text-3xl md:text-4xl font-bold text-forest mb-6" data-id="element-20">
              Pero eso no es todo lo que vas a recibir hoy
            </h2>
            <p className="text-lg text-gray-700 leading-relaxed mb-4" data-id="element-21">
              Cuando decidimos crear el Protocolo de Rescate para Tus Riñones,
              sabíamos que el plan de 14 días era solo el comienzo.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed mb-4" data-id="element-22">
              Porque la realidad es esta:
            </p>
            <p className="text-lg text-gray-700 leading-relaxed mb-4" data-id="element-23">
              Muchas personas tienen el protocolo. Muchas personas tienen la
              información. Pero muy pocas saben exactamente qué comer cada día o
              cómo organizar su rutina para no abandonar a mitad de camino.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed font-semibold" data-id="element-24">
              Por eso decidimos incluir 2 bonos adicionales completamente gratis
              para las personas que tomen acción hoy.
            </p>
          </div>
        </FadeIn>

        {/* BLOCK 2 */}
        <FadeIn delay={0.2} data-id="element-25">
          <div className="bg-white rounded-2xl p-8 shadow-md border border-gray-100 mb-16" data-id="element-26">
            <h3 className="text-2xl font-bold text-center text-forest mb-6" data-id="element-27">
              Junto con tu protocolo principal vas a recibir esto sin costo
              adicional
            </h3>
            <p className="text-gray-700 mb-4 text-center" data-id="element-28">
              Estos bonos fueron diseñados para resolver las 2 razones más
              comunes por las que las personas no logran completar un plan de
              salud:
            </p>
            <div className="bg-red-50 p-6 rounded-xl border border-red-100 mb-6" data-id="element-29">
              <p className="text-red-800 font-medium mb-2" data-id="element-30">
                <span className="font-bold" data-id="element-31">Razón 1:</span> No saben qué comer
                en el día a día sin complicarse.
              </p>
              <p className="text-red-800 font-medium" data-id="element-32">
                <span className="font-bold" data-id="element-33">Razón 2:</span> Se sienten
                confundidos con su rutina y terminan abandonando.
              </p>
            </div>
            <p className="text-gray-700 text-center italic" data-id="element-34">
              Si alguna vez sentiste alguna de estas dos cosas, los siguientes
              bonos fueron creados exactamente para ti.
            </p>
          </div>
        </FadeIn>

        {/* BLOCK 3 - BONUS 1 */}
        <FadeIn delay={0.3} data-id="element-35">
          <div className="bg-white rounded-3xl overflow-hidden shadow-xl border-2 border-amber/30 mb-16" data-id="element-36">
            <div className="grid md:grid-cols-2 gap-0" data-id="element-37">
              <div className="p-8 md:p-10" data-id="element-38">
                <div className="flex items-center gap-3 mb-4" data-id="element-39">
                  <Gift className="w-8 h-8 text-amber shrink-0" data-id="element-40" />
                  <h3 className="text-2xl font-bold text-forest" data-id="element-41">
                    BONO #1 — KIT DE COMIDAS SEGURAS EN 5 MINUTOS
                  </h3>
                </div>
                <p className="text-amber font-bold mb-6 text-lg" data-id="element-42">
                  Valor real: $47 — Hoy completamente GRATIS
                </p>
                <p className="text-gray-700 mb-4" data-id="element-43">
                  ¿Cuántas veces llegaste a la hora de comer y no sabías qué
                  preparar?
                </p>
                <p className="text-gray-700 mb-4" data-id="element-44">
                  Esa pregunta parece pequeña. Pero cuando aparece todos los
                  días, se convierte en uno de los mayores obstáculos para
                  seguir cualquier plan de salud.
                </p>
                <p className="text-gray-700 mb-6" data-id="element-45">
                  El Kit de Comidas Seguras en 5 Minutos resuelve exactamente
                  eso. No te va a dar recetas complicadas. No te va a pedir
                  ingredientes difíciles de conseguir. Te va a dar algo mucho
                  más valioso:{' '}
                  <span className="font-semibold" data-id="element-46">
                    Una forma simple y repetible de saber qué comer sin pensar
                    demasiado.
                  </span>
                </p>

                <p className="font-bold text-gray-900 mb-4" data-id="element-47">
                  Con este bono vas a tener:
                </p>
                <ul className="space-y-3 mb-8" data-id="element-48">
                  {['La fórmula 3x3 para armar platos seguros en minutos sin improvisación', '12 desayunos rápidos que puedes repetir sin aburrirte', '12 almuerzos y cenas fáciles de preparar con lo que ya tienes en casa', '10 ideas de emergencia para días ocupados cuando no quieres cocinar', 'Un checklist rápido para confirmar que tu comida es segura antes de prepararla', 'Un mini workbook semanal para dejar tus comidas decididas de antemano'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-49">
                      <CheckCircle2 className="w-5 h-5 text-green-500 shrink-0 mt-0.5" data-id="element-50" />
                      <span className="text-gray-700" data-id="element-51">{item}</span>
                    </li>)}
                </ul>

                <div className="bg-green-50 p-6 rounded-xl mb-6" data-id="element-52">
                  <p className="text-gray-800 font-medium mb-4" data-id="element-53">
                    <span className="font-bold" data-id="element-54">
                      Lo que este bono hace por ti:
                    </span>{' '}
                    Elimina la confusión en la hora de comer. Te da claridad
                    inmediata desde el primer día. Reduce errores por
                    improvisación. Y te ayuda a seguir el protocolo sin sentirte
                    perdido cada vez que tienes hambre.
                  </p>
                  <p className="text-forest italic font-medium" data-id="element-55">
                    "Ya no me pregunto qué comer. Tengo mis opciones claras y
                    las repito sin estrés."
                  </p>
                </div>

                <div className="border-t border-gray-100 pt-4 flex justify-between items-center" data-id="element-56">
                  <span className="text-gray-500 line-through" data-id="element-57">
                    Valor real de este bono: $47
                  </span>
                  <span className="text-xl font-bold text-green-600" data-id="element-58">
                    Tu costo hoy: $0
                  </span>
                </div>
              </div>
              <div className="bg-gray-50 flex items-center justify-center p-6" data-id="element-59">
                <img src="https://cdn.magicpatterns.com/uploads/mbXgcchaiFNhcVtFeJa9yw/BONO1.png" alt="Kit de Comidas Seguras en 5 Minutos" className="w-full h-auto rounded-xl shadow-md" data-id="element-60" />
              </div>
            </div>
          </div>
        </FadeIn>

        {/* BLOCK 4 - BONUS 2 */}
        <FadeIn delay={0.4} data-id="element-61">
          <div className="bg-white rounded-3xl overflow-hidden shadow-xl border-2 border-amber/30 mb-16" data-id="element-62">
            <div className="grid md:grid-cols-2 gap-0" data-id="element-63">
              <div className="bg-gray-50 flex items-center justify-center p-6 order-2 md:order-1" data-id="element-64">
                <img src="https://cdn.magicpatterns.com/uploads/3D8jH2RTBRZDx19jjQJtCB/BONO2.png" alt="Guía Express para Entender tu Rutina Renal" className="w-full h-auto rounded-xl shadow-md" data-id="element-65" />
              </div>
              <div className="p-8 md:p-10 order-1 md:order-2" data-id="element-66">
                <div className="flex items-center gap-3 mb-4" data-id="element-67">
                  <Gift className="w-8 h-8 text-amber shrink-0" data-id="element-68" />
                  <h3 className="text-2xl font-bold text-forest" data-id="element-69">
                    BONO #2 — GUÍA EXPRESS PARA ENTENDER TU RUTINA RENAL SIN
                    CONFUSIÓN
                  </h3>
                </div>
                <p className="text-amber font-bold mb-6 text-lg" data-id="element-70">
                  Valor real: $47 — Hoy completamente GRATIS
                </p>
                <p className="text-gray-700 mb-4" data-id="element-71">
                  La mayoría de las personas no abandona un plan por falta de
                  motivación. Lo abandona por exceso de confusión.
                </p>
                <p className="text-gray-700 mb-4" data-id="element-72">
                  Cuando no sabes exactamente qué hacer en la mañana, en la
                  tarde y en la noche, tu mente empieza a generar preguntas que
                  no tienen respuesta clara:
                </p>
                <ul className="list-disc pl-5 text-gray-700 mb-4 space-y-1 italic" data-id="element-73">
                  <li data-id="element-74">¿Estoy haciendo esto bien?</li>
                  <li data-id="element-75">¿Cuándo tomo el agua?</li>
                  <li data-id="element-76">¿Qué hago primero?</li>
                  <li data-id="element-77">¿Cómo sé si esto está funcionando?</li>
                </ul>
                <p className="text-gray-700 mb-6" data-id="element-78">
                  Y cuando las preguntas se acumulan, llega el cansancio mental.
                  Y cuando llega el cansancio mental, llega el abandono. La Guía
                  Express fue creada para que eso no te pase.
                </p>

                <p className="font-bold text-gray-900 mb-4" data-id="element-79">
                  Con este bono vas a tener:
                </p>
                <ul className="space-y-3 mb-8" data-id="element-80">
                  {['La rutina simple de 3 bloques: mañana, tarde y noche para no improvisar nada', 'Checklist de mañana para empezar el día con dirección clara', 'Checklist de tarde para no romper la rutina en el momento más difícil', 'Checklist de noche para cerrar bien el día y preparar el siguiente', 'Los 7 errores más comunes que hacen que las personas abandonen su plan', 'Un ejemplo de rutina completa lista para copiar y usar desde hoy', 'Una hoja de implementación diaria para tener todo claro en un solo lugar'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-81">
                      <CheckCircle2 className="w-5 h-5 text-green-500 shrink-0 mt-0.5" data-id="element-82" />
                      <span className="text-gray-700" data-id="element-83">{item}</span>
                    </li>)}
                </ul>

                <div className="bg-green-50 p-6 rounded-xl mb-6" data-id="element-84">
                  <p className="text-gray-800 font-medium mb-4" data-id="element-85">
                    <span className="font-bold" data-id="element-86">
                      Lo que este bono hace por ti:
                    </span>{' '}
                    Convierte el protocolo en una rutina simple que puedes
                    entender y repetir. Reduce la confusión que sabotea los
                    buenos hábitos. Te da estructura sin sentirte presionado. Y
                    te acompaña para que no abandones cuando el proceso se ponga
                    difícil.
                  </p>
                  <p className="text-forest italic font-medium" data-id="element-87">
                    "Antes me confundía con qué hacer primero. Ahora tengo claro
                    qué hacer mañana, tarde y noche."
                  </p>
                </div>

                <div className="border-t border-gray-100 pt-4 flex justify-between items-center" data-id="element-88">
                  <span className="text-gray-500 line-through" data-id="element-89">
                    Valor real de este bono: $47
                  </span>
                  <span className="text-xl font-bold text-green-600" data-id="element-90">
                    Tu costo hoy: $0
                  </span>
                </div>
              </div>
            </div>
          </div>
        </FadeIn>

        {/* BLOCK 5 - SUMMARY TABLE */}
        <FadeIn delay={0.5} data-id="element-91">
          <div className="bg-white rounded-3xl p-8 shadow-xl border border-gray-200 mb-16" data-id="element-92">
            <h3 className="text-3xl font-bold text-center text-forest mb-8" data-id="element-93">
              Todo lo que recibes hoy
            </h3>
            <div className="overflow-x-auto" data-id="element-94">
              <table className="w-full text-left border-collapse" data-id="element-95">
                <thead data-id="element-96">
                  <tr className="border-b-2 border-gray-100" data-id="element-97">
                    <th className="pb-4 font-bold text-gray-900 text-lg" data-id="element-98">
                      Lo que incluye
                    </th>
                    <th className="pb-4 font-bold text-gray-900 text-lg text-right" data-id="element-99">
                      Valor real
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100" data-id="element-100">
                  <tr data-id="element-101">
                    <td className="py-4 flex items-center gap-3" data-id="element-102">
                      <CheckCircle2 className="w-5 h-5 text-green-500 shrink-0" data-id="element-103" />
                      <span className="text-gray-800" data-id="element-104">
                        Protocolo de Rescate para Tus Riñones — Plan completo de
                        14 días
                      </span>
                    </td>
                    <td className="py-4 text-right font-medium text-gray-600" data-id="element-105">
                      Incluido
                    </td>
                  </tr>
                  <tr data-id="element-106">
                    <td className="py-4 flex items-center gap-3" data-id="element-107">
                      <CheckCircle2 className="w-5 h-5 text-green-500 shrink-0" data-id="element-108" />
                      <span className="text-gray-800" data-id="element-109">
                        Recetario Sabor Renal — 50 recetas simples y compatibles
                      </span>
                    </td>
                    <td className="py-4 text-right font-medium text-gray-600" data-id="element-110">
                      Incluido
                    </td>
                  </tr>
                  <tr data-id="element-111">
                    <td className="py-4 flex items-center gap-3" data-id="element-112">
                      <CheckCircle2 className="w-5 h-5 text-green-500 shrink-0" data-id="element-113" />
                      <span className="text-gray-800" data-id="element-114">
                        Guía de Hidratación Osmótica
                      </span>
                    </td>
                    <td className="py-4 text-right font-medium text-gray-600" data-id="element-115">
                      Incluido
                    </td>
                  </tr>
                  <tr className="bg-amber/5" data-id="element-116">
                    <td className="py-4 flex items-center gap-3 px-2 rounded-l-lg" data-id="element-117">
                      <Gift className="w-5 h-5 text-amber shrink-0" data-id="element-118" />
                      <span className="text-gray-900 font-semibold" data-id="element-119">
                        BONO 1: Kit de Comidas Seguras en 5 Minutos
                      </span>
                    </td>
                    <td className="py-4 text-right px-2 rounded-r-lg" data-id="element-120">
                      <span className="line-through text-gray-400 mr-2" data-id="element-121">
                        $47
                      </span>
                      <span className="font-bold text-green-600" data-id="element-122">GRATIS</span>
                    </td>
                  </tr>
                  <tr className="bg-amber/5" data-id="element-123">
                    <td className="py-4 flex items-center gap-3 px-2 rounded-l-lg" data-id="element-124">
                      <Gift className="w-5 h-5 text-amber shrink-0" data-id="element-125" />
                      <span className="text-gray-900 font-semibold" data-id="element-126">
                        BONO 2: Guía Express para Entender tu Rutina Renal sin
                        Confusión
                      </span>
                    </td>
                    <td className="py-4 text-right px-2 rounded-r-lg" data-id="element-127">
                      <span className="line-through text-gray-400 mr-2" data-id="element-128">
                        $47
                      </span>
                      <span className="font-bold text-green-600" data-id="element-129">GRATIS</span>
                    </td>
                  </tr>
                </tbody>
                <tfoot data-id="element-130">
                  <tr className="border-t-2 border-gray-200" data-id="element-131">
                    <td className="pt-6 pb-2 font-bold text-gray-600 text-right" data-id="element-132">
                      Valor total real:
                    </td>
                    <td className="pt-6 pb-2 font-bold text-gray-500 line-through text-right text-xl" data-id="element-133">
                      $94 en bonos
                    </td>
                  </tr>
                  <tr data-id="element-134">
                    <td className="py-2 font-black text-forest text-xl text-right" data-id="element-135">
                      Tu inversión hoy:
                    </td>
                    <td className="py-2 font-black text-amber text-2xl text-right" data-id="element-136">
                      Lo que ves en el botón
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </FadeIn>

        {/* BLOCK 6 - URGENCY */}
        <FadeIn delay={0.6} data-id="element-137">
          <div className="text-center mb-12" data-id="element-138">
            <h3 className="text-2xl md:text-3xl font-bold text-forest mb-6" data-id="element-139">
              Estos bonos no siempre van a estar disponibles
            </h3>
            <p className="text-lg text-gray-700 mb-4" data-id="element-140">
              Los incluimos porque queremos que tengas todo lo necesario para
              completar el protocolo con éxito. Pero son un regalo temporal para
              las personas que toman acción hoy.
            </p>
            <p className="text-lg text-red-600 font-bold mb-8" data-id="element-141">
              No podemos garantizar que sigan disponibles mañana.
            </p>

            <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-200 text-left" data-id="element-142">
              <p className="font-bold text-xl mb-6 text-center" data-id="element-143">
                Tienes dos opciones en este momento:
              </p>
              <div className="space-y-6" data-id="element-144">
                <div className="flex gap-4" data-id="element-145">
                  <div className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center font-bold text-gray-600 shrink-0" data-id="element-146">
                    1
                  </div>
                  <p className="text-gray-700" data-id="element-147">
                    <span className="font-bold" data-id="element-148">Opción 1:</span> Cerrar esta
                    página, seguir buscando respuestas y seguir sintiéndote
                    confundido con qué comer y cómo organizar tu rutina.
                  </p>
                </div>
                <div className="flex gap-4" data-id="element-149">
                  <div className="w-8 h-8 rounded-full bg-amber flex items-center justify-center font-bold text-white shrink-0" data-id="element-150">
                    2
                  </div>
                  <p className="text-gray-900" data-id="element-151">
                    <span className="font-bold" data-id="element-152">Opción 2:</span> Tomar acción
                    hoy, acceder al protocolo completo y recibir los 2 bonos que
                    van a hacer que todo sea más fácil desde el primer día.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </FadeIn>

        {/* BLOCK 7 - FINAL CTA */}
        <FadeIn delay={0.7} data-id="element-153">
          <div className="bg-forest text-white rounded-3xl p-8 md:p-12 shadow-2xl text-center" data-id="element-154">
            <h3 className="text-3xl md:text-4xl font-bold mb-8" data-id="element-155">
              Haz clic abajo y accede ahora mismo
            </h3>

            <div className="bg-white/10 rounded-2xl p-6 mb-8 text-left max-w-lg mx-auto" data-id="element-156">
              <p className="font-bold text-xl mb-4 text-center" data-id="element-157">
                Vas a recibir acceso inmediato a:
              </p>
              <ul className="space-y-3" data-id="element-158">
                <li className="flex items-center gap-3" data-id="element-159">
                  <CheckCircle2 className="w-5 h-5 text-green-400 shrink-0" data-id="element-160" />
                  <span data-id="element-161">El Protocolo de Rescate para Tus Riñones</span>
                </li>
                <li className="flex items-center gap-3" data-id="element-162">
                  <CheckCircle2 className="w-5 h-5 text-green-400 shrink-0" data-id="element-163" />
                  <span data-id="element-164">Todos los materiales incluidos</span>
                </li>
                <li className="flex items-center gap-3" data-id="element-165">
                  <Gift className="w-5 h-5 text-amber shrink-0" data-id="element-166" />
                  <span className="font-bold" data-id="element-167">
                    BONO 1: Kit de Comidas Seguras en 5 Minutos — GRATIS
                  </span>
                </li>
                <li className="flex items-center gap-3" data-id="element-168">
                  <Gift className="w-5 h-5 text-amber shrink-0" data-id="element-169" />
                  <span className="font-bold" data-id="element-170">
                    BONO 2: Guía Express para Entender tu Rutina Renal sin
                    Confusión — GRATIS
                  </span>
                </li>
              </ul>
            </div>

            <CTAButton className="w-full md:w-auto text-lg md:text-xl py-6 px-10 mb-8" onClick={() => {
            document.getElementById('offer-section')?.scrollIntoView({
              behavior: 'smooth'
            });
          }} data-id="element-171">
              ¡SÍ, QUIERO MI CUPO Y MIS BONOS POR SOLAMENTE $8!
            </CTAButton>

            <div className="flex flex-col items-center justify-center gap-4 text-cream/90 max-w-2xl mx-auto" data-id="element-172">
              <ShieldCheck className="w-12 h-12 text-blue-400" data-id="element-173" />
              <p className="font-bold text-lg" data-id="element-174">Garantía de Rescate de 7 Días</p>
              <p className="text-sm" data-id="element-175">
                Si en los próximos 7 días sientes que esto no es para ti, te
                devolvemos el 100% de tu dinero sin preguntas y sin
                complicaciones. No tienes nada que perder y mucho que ganar.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}